
























import { Component, Vue, Prop } from 'vue-property-decorator'

import { mdiLogout, mdiPhoneOutline, mdiChevronDown, mdiEye } from '@mdi/js'

import NotificationBar from '@/components/layouts/app/NotificationBar.vue'
import PortalNavigationMenu from '@/components/layouts/PortalNavigationMenu.vue'

@Component({
  components: {
    NotificationBar,
    PortalNavigationMenu,
  },
})
class UnauthorizedHeader extends Vue {
  @Prop({
    type: String,
    default: '',
  })
  readonly phone: string

  @Prop({
    type: String,
    default: '',
  })
  readonly portalLink: string

  icons = {
    mdiLogout,
    mdiPhoneOutline,
    mdiChevronDown,
    mdiEye,
  }
}

export default UnauthorizedHeader
